import { curry } from 'lodash';
import React from 'react';

import { defaultLocationSearch, LOCATION_SEARCHES } from '../constants';
import DealerLocatorContext from '../DealerLocatorContext';

export const toggleIsRouteSearch = curry(
  (setContext, [assetLocationSearch], currentIsRouteSearch) => {
    // If currentIsRouteSearch is true, the user is switching _to_ an area search.
    // Keep the assetLocationSearch and clear the rest.
    const locationSearches = currentIsRouteSearch
      ? [assetLocationSearch]
      : [assetLocationSearch, defaultLocationSearch];

    return setContext({
      [LOCATION_SEARCHES]: locationSearches,
      highlightedDealer: undefined,
      isRouteSearch: !currentIsRouteSearch,
    });
  },
);

export const buildConsumerChild = curry(
  (WrappedComponent, componentProps, consumerProps) => {
    const {
      isRouteSearch,
      [LOCATION_SEARCHES]: locationSearches,
      updateDealerLocatorContext,
    } = consumerProps;

    return (
      <WrappedComponent
        {...componentProps}
        isRouteSearch={isRouteSearch}
        toggleIsRouteSearch={toggleIsRouteSearch(
          updateDealerLocatorContext,
          locationSearches,
        )}
      />
    );
  },
);

const withIsRouteSearch = WrappedComponent => componentProps => (
  <DealerLocatorContext.Consumer>
    {buildConsumerChild(WrappedComponent, componentProps)}
  </DealerLocatorContext.Consumer>
);

export default withIsRouteSearch;



// WEBPACK FOOTER //
// ./src/compositions/DealerLocator/withIsRouteSearch/index.js